<template>
    <div id="signup_v2" class="_bg-red-100">
        <div class="form-control">
            <div class="form-element">
                <p class="form-title">Civilité</p>
                <div class="gender_wrapper">
                    <div v-for="(answer, answer_key) in ['Madame', 'Monsieur']" :key="answer_key">
                        <label class="type_radio" :for="answer">
                            {{ answer }}
                            <input ref="gender" type="radio" :value="answer.toLowerCase()" name="gender" :id="answer" v-model="form_register.gender"/>
                            <span class="checkmark"></span>
                        </label>
                    </div>
                </div>
            </div>
            <div class="form-element">
                <p class="form-title">Fonction *</p>
                <select id="fonction" name="fonction" class="type_text" v-model="form_register.fonction">
                    <option value='COMPTABLE'>COMPTABLE</option>
                    <option value='DIRECTEUR GENERAL'>DIRECTEUR GENERAL</option>
                    <option value='DIRCTEUR DE LABORATOIRE'>DIRECTEUR DE LABORATOIRE</option>
                    <option value='OPERATEUR DE LABORATOIRE'>OPERATEUR DE LABORATOIRE</option>
                    <option value='DIRECTEUR MARKETING'>DIRECTEUR MARKETING</option>
                    <option value='DIRECTEUR ADMINISTRATIF'>DIRECTEUR ADMINISTRATIF</option>
                    <option value='OPERATEUR '>OPERATEUR</option>
                    <option value='ACHETEUR'>ACHETEUR</option>
                    <option value='CHEF DE PROJET'>CHEF DE PROJET</option>
                    <option value='PRODUCTION / GESTIONNAIRE DE PROCESSUS'>PRODUCTION / GESTIONNAIRE DE PROCESSUS</option>
                    <option value='PROFESSEUR'>PROFESSEUR</option>
                    <option value='RESPONSABLE QUALITE'>RESPONSABLE QUALITE</option>
                    <option value='CHERCHEUR'>CHERCHEUR</option>
                    <option value='DIRECTEUR RECHERCHE ET DEVELOPPEMENT'>DIRECTEUR RECHERCHE ET DEVELOPPEMENT</option>
                    <option value='SECRETAIRE'>SECRETAIRE</option>
                    <option value='DIRECTEUR DES VENTES'>DIRECTEUR DES VENTES</option>
                    <option value='COMMERCIAL'>COMMERCIAL</option>
                    <option value='TECHNICIEN'>TECHNICIEN</option>
                    <option value='DIRECTEUR TECHNIQUE'>DIRECTEUR TECHNIQUE</option>
                    <option value='DIRECTEUR DE MAGASIN'>DIRECTEUR DE MAGASIN</option>
                    <option value='DIRECTEUR DES EAUX USEES'>DIRECTEUR DES EAUX USEES</option>
                </select>
            </div>
        </div>

        <div class="form-control">
            <div class="form-element">
                <p class="form-title">Nom *</p>
                <input class="type_text" v-model="form_register.nom"/>
            </div>
            <div class="form-element">
                <p class="form-title">Prenom *</p>
                <input class="type_text" v-model="form_register.prenom"/>
            </div>
        </div>

        <div class="form-control">
            <div class="form-element">
                <p class="form-title">Nom de l’entreprise *</p>
                <input class="type_text" v-model="form_register.entreprise"/>
            </div>
            <div class="form-element">
                <p class="form-title">Numéro de TVA *</p>
                <input class="type_text" v-model="form_register.tva"/>
            </div>
        </div>

        <div class="form-control">
            <div class="form-element">
                <p class="form-title">Secteur *</p>
                <select id="secteur" name="secteur" class="type_text" v-model="form_register.secteur">
                    <option value='Aeronautique'>Aeronautique</option>
                    <option value='Agriculture'>Agriculture</option>
                    <option value='Aquarium/aquaculture'>Aquarium/aquaculture</option>
                    <option value='Autres'>Autres</option>
                    <option value='Bétail'>Bétail</option>
                    <option value='Biotechnologie'>Biotechnologie</option>
                    <option value='Brasseries'>Brasseries</option>
                    <option value='Chauffage'>Chauffage</option>
                    <option value='Construction'>Construction</option>
                    <option value='Cosmétiques'>Cosmétiques</option>
                    <option value='Enseignement'>Enseignement</option>
                    <option value='Environnement'>Environnement</option>
                    <option value='Growshops'>Growshops</option>
                    <option value='Horticulture'>Horticulture</option>
                    <option value='Hôtels Restaurants Cafés'>Hôtels Restaurants Cafés</option>
                    <option value='Imprimerie'>Imprimerie</option>
                    <option value='Industrie Alimentaire'>Industrie Alimentaire</option>
                    <option value='Industrie Automobile'>Industrie Automobile</option>
                    <option value='Industrie Chimique'>Industrie Chimique</option>
                    <option value='Industrie de la Peinture'>Industrie de la Peinture</option>
                    <option value="Industrie de l'Energie">Industrie de l'Energie</option>
                    <option value='Industrie des Boissons'>Industrie des Boissons</option>
                    <option value='Industrie du nettoyage'>Industrie du nettoyage</option>
                    <option value='Industrie du Verre'>Industrie du Verre</option>
                    <option value='Industrie Eau Potable'>Industrie Eau Potable</option>
                    <option value='Industrie Electronique'>Industrie Electronique</option>
                    <option value='Industrie Laitière'>Industrie Laitière</option>
                    <option value='Industrie Métallurgique'>Industrie Métallurgique</option>
                    <option value='Industrie Papetière'>Industrie Papetière</option>
                    <option value='Industrie Pétrochimique'>Industrie Pétrochimique</option>
                    <option value='Industrie Pharmaceutique'>Industrie Pharmaceutique</option>
                    <option value='Industrie Photographique'>Industrie Photographique</option>
                    <option value='Industrie Piscine'>Industrie Piscine</option>
                    <option value='Industrie Sucrière'>Industrie Sucrière</option>
                    <option value='Industrie Textile'>Industrie Textile</option>
                    <option value='Institut Scientifique'>Institut Scientifique</option>
                    <option value='Laboratoires'>Laboratoires</option>
                    <option value='Labos Reconnus ou accrédités'>Labos Reconnus ou accrédités</option>
                    <option value='Matériaux de construction'>Matériaux de construction</option>
                    <option value='Nettoyage et stockage Cuves'>Nettoyage et stockage Cuves</option>
                    <option value='Nettoyage industriel'>Nettoyage industriel</option>
                    <option value='Plasturgie'>Plasturgie</option>
                    <option value='Secteur Médical'>Secteur Médical</option>
                    <option value='Service Public'>Service Public</option>
                    <option value="Société d'Ingénierie">Société d'Ingénierie</option>
                    <option value='Supermarchés'>Supermarchés</option>
                    <option value='Testeurs et testkits'>Testeurs et testkits</option>
                    <option value='Thermo, pH (HACCP)'>Thermo, pH (HACCP)</option>
                    <option value='Trader'>Trader</option>
                    <option value='Traitement des Déchêts'>Traitement des Déchêts</option>
                    <option value="Traitement de l'Eau">Traitement de l'Eau</option>
                    <option value='Transport '>Transport</option>
                    <option value='Universités'>Universités</option>
                    <option value='Viti/Viniculture'>Viti/Viniculture</option>
                    <option value='Vétérinaire'>Vétérinaire</option>
                </select>
            </div>
            <div class="form-element">
                <p class="form-title">Site web</p>
                <input class="type_text" v-model="form_register.web"/>
            </div>
        </div>

        <div class="form-control">
            <div class="form-element">
                <p class="form-title">Téléphone *</p>
                <input class="type_text" v-model="form_register.telephone"/>
            </div>
            <div class="form-element">
                <p class="form-title">Portable</p>
                <input class="type_text" v-model="form_register.telephone_portable"/>
            </div>
        </div>

        <div class="form-control">
            <div class="form-element form-addresse">
                <p class="form-title">Adresse de livraison / Rue et N° *</p>
                <input class="type_text" v-model="form_register.addresse"/>
            </div>
        </div>

        <div class="form-control">
            <div class="form-element">
                <p class="form-title">Code postal *</p>
                <input class="type_text" v-model="form_register.code_postal"/>
            </div>
            <div class="form-element">
                <p class="form-title">Ville *</p>
                <input class="type_text" v-model="form_register.ville"/>
            </div>
            <div class="form-element">
                <p class="form-title">Pays *</p>
                <select id="country" name="country" class="type_text" v-model="form_register.country">
                    <option value="Afghanistan">Afghanistan</option>
                    <option value="Åland Islands">Åland Islands</option>
                    <option value="Albania">Albania</option>
                    <option value="Algeria">Algeria</option>
                    <option value="American Samoa">American Samoa</option>
                    <option value="Andorra">Andorra</option>
                    <option value="Angola">Angola</option>
                    <option value="Anguilla">Anguilla</option>
                    <option value="Antarctica">Antarctica</option>
                    <option value="Antigua and Barbuda">Antigua and Barbuda</option>
                    <option value="Argentina">Argentina</option>
                    <option value="Armenia">Armenia</option>
                    <option value="Aruba">Aruba</option>
                    <option value="Australia">Australia</option>
                    <option value="Austria">Austria</option>
                    <option value="Azerbaijan">Azerbaijan</option>
                    <option value="Bahamas">Bahamas</option>
                    <option value="Bahrain">Bahrain</option>
                    <option value="Bangladesh">Bangladesh</option>
                    <option value="Barbados">Barbados</option>
                    <option value="Belarus">Belarus</option>
                    <option value="Belgium">Belgium</option>
                    <option value="Belize">Belize</option>
                    <option value="Benin">Benin</option>
                    <option value="Bermuda">Bermuda</option>
                    <option value="Bhutan">Bhutan</option>
                    <option value="Bolivia">Bolivia</option>
                    <option value="Bosnia and Herzegovina">Bosnia and Herzegovina</option>
                    <option value="Botswana">Botswana</option>
                    <option value="Bouvet Island">Bouvet Island</option>
                    <option value="Brazil">Brazil</option>
                    <option value="British Indian Ocean Territory">British Indian Ocean Territory</option>
                    <option value="Brunei Darussalam">Brunei Darussalam</option>
                    <option value="Bulgaria">Bulgaria</option>
                    <option value="Burkina Faso">Burkina Faso</option>
                    <option value="Burundi">Burundi</option>
                    <option value="Cambodia">Cambodia</option>
                    <option value="Cameroon">Cameroon</option>
                    <option value="Canada">Canada</option>
                    <option value="Cape Verde">Cape Verde</option>
                    <option value="Cayman Islands">Cayman Islands</option>
                    <option value="Central African Republic">Central African Republic</option>
                    <option value="Chad">Chad</option>
                    <option value="Chile">Chile</option>
                    <option value="China">China</option>
                    <option value="Christmas Island">Christmas Island</option>
                    <option value="Cocos (Keeling) Islands">Cocos (Keeling) Islands</option>
                    <option value="Colombia">Colombia</option>
                    <option value="Comoros">Comoros</option>
                    <option value="Congo">Congo</option>
                    <option value="Congo, The Democratic Republic of The">Congo, The Democratic Republic of The</option>
                    <option value="Cook Islands">Cook Islands</option>
                    <option value="Costa Rica">Costa Rica</option>
                    <option value="Cote D'ivoire">Cote D'ivoire</option>
                    <option value="Croatia">Croatia</option>
                    <option value="Cuba">Cuba</option>
                    <option value="Cyprus">Cyprus</option>
                    <option value="Czech Republic">Czech Republic</option>
                    <option value="Denmark">Denmark</option>
                    <option value="Djibouti">Djibouti</option>
                    <option value="Dominica">Dominica</option>
                    <option value="Dominican Republic">Dominican Republic</option>
                    <option value="Ecuador">Ecuador</option>
                    <option value="Egypt">Egypt</option>
                    <option value="El Salvador">El Salvador</option>
                    <option value="Equatorial Guinea">Equatorial Guinea</option>
                    <option value="Eritrea">Eritrea</option>
                    <option value="Estonia">Estonia</option>
                    <option value="Ethiopia">Ethiopia</option>
                    <option value="Falkland Islands (Malvinas)">Falkland Islands (Malvinas)</option>
                    <option value="Faroe Islands">Faroe Islands</option>
                    <option value="Fiji">Fiji</option>
                    <option value="Finland">Finland</option>
                    <option value="France">France</option>
                    <option value="French Guiana">French Guiana</option>
                    <option value="French Polynesia">French Polynesia</option>
                    <option value="French Southern Territories">French Southern Territories</option>
                    <option value="Gabon">Gabon</option>
                    <option value="Gambia">Gambia</option>
                    <option value="Georgia">Georgia</option>
                    <option value="Germany">Germany</option>
                    <option value="Ghana">Ghana</option>
                    <option value="Gibraltar">Gibraltar</option>
                    <option value="Greece">Greece</option>
                    <option value="Greenland">Greenland</option>
                    <option value="Grenada">Grenada</option>
                    <option value="Guadeloupe">Guadeloupe</option>
                    <option value="Guam">Guam</option>
                    <option value="Guatemala">Guatemala</option>
                    <option value="Guernsey">Guernsey</option>
                    <option value="Guinea">Guinea</option>
                    <option value="Guinea-bissau">Guinea-bissau</option>
                    <option value="Guyana">Guyana</option>
                    <option value="Haiti">Haiti</option>
                    <option value="Heard Island and Mcdonald Islands">Heard Island and Mcdonald Islands</option>
                    <option value="Holy See (Vatican City State)">Holy See (Vatican City State)</option>
                    <option value="Honduras">Honduras</option>
                    <option value="Hong Kong">Hong Kong</option>
                    <option value="Hungary">Hungary</option>
                    <option value="Iceland">Iceland</option>
                    <option value="India">India</option>
                    <option value="Indonesia">Indonesia</option>
                    <option value="Iran, Islamic Republic of">Iran, Islamic Republic of</option>
                    <option value="Iraq">Iraq</option>
                    <option value="Ireland">Ireland</option>
                    <option value="Isle of Man">Isle of Man</option>
                    <option value="Israel">Israel</option>
                    <option value="Italy">Italy</option>
                    <option value="Jamaica">Jamaica</option>
                    <option value="Japan">Japan</option>
                    <option value="Jersey">Jersey</option>
                    <option value="Jordan">Jordan</option>
                    <option value="Kazakhstan">Kazakhstan</option>
                    <option value="Kenya">Kenya</option>
                    <option value="Kiribati">Kiribati</option>
                    <option value="Korea, Democratic People's Republic of">Korea, Democratic People's Republic of</option>
                    <option value="Korea, Republic of">Korea, Republic of</option>
                    <option value="Kuwait">Kuwait</option>
                    <option value="Kyrgyzstan">Kyrgyzstan</option>
                    <option value="Lao People's Democratic Republic">Lao People's Democratic Republic</option>
                    <option value="Latvia">Latvia</option>
                    <option value="Lebanon">Lebanon</option>
                    <option value="Lesotho">Lesotho</option>
                    <option value="Liberia">Liberia</option>
                    <option value="Libyan Arab Jamahiriya">Libyan Arab Jamahiriya</option>
                    <option value="Liechtenstein">Liechtenstein</option>
                    <option value="Lithuania">Lithuania</option>
                    <option value="Luxembourg">Luxembourg</option>
                    <option value="Macao">Macao</option>
                    <option value="Macedonia, The Former Yugoslav Republic of">Macedonia, The Former Yugoslav Republic of</option>
                    <option value="Madagascar">Madagascar</option>
                    <option value="Malawi">Malawi</option>
                    <option value="Malaysia">Malaysia</option>
                    <option value="Maldives">Maldives</option>
                    <option value="Mali">Mali</option>
                    <option value="Malta">Malta</option>
                    <option value="Marshall Islands">Marshall Islands</option>
                    <option value="Martinique">Martinique</option>
                    <option value="Mauritania">Mauritania</option>
                    <option value="Mauritius">Mauritius</option>
                    <option value="Mayotte">Mayotte</option>
                    <option value="Mexico">Mexico</option>
                    <option value="Micronesia, Federated States of">Micronesia, Federated States of</option>
                    <option value="Moldova, Republic of">Moldova, Republic of</option>
                    <option value="Monaco">Monaco</option>
                    <option value="Mongolia">Mongolia</option>
                    <option value="Montenegro">Montenegro</option>
                    <option value="Montserrat">Montserrat</option>
                    <option value="Morocco">Morocco</option>
                    <option value="Mozambique">Mozambique</option>
                    <option value="Myanmar">Myanmar</option>
                    <option value="Namibia">Namibia</option>
                    <option value="Nauru">Nauru</option>
                    <option value="Nepal">Nepal</option>
                    <option value="Netherlands">Netherlands</option>
                    <option value="Netherlands Antilles">Netherlands Antilles</option>
                    <option value="New Caledonia">New Caledonia</option>
                    <option value="New Zealand">New Zealand</option>
                    <option value="Nicaragua">Nicaragua</option>
                    <option value="Niger">Niger</option>
                    <option value="Nigeria">Nigeria</option>
                    <option value="Niue">Niue</option>
                    <option value="Norfolk Island">Norfolk Island</option>
                    <option value="Northern Mariana Islands">Northern Mariana Islands</option>
                    <option value="Norway">Norway</option>
                    <option value="Oman">Oman</option>
                    <option value="Pakistan">Pakistan</option>
                    <option value="Palau">Palau</option>
                    <option value="Palestinian Territory, Occupied">Palestinian Territory, Occupied</option>
                    <option value="Panama">Panama</option>
                    <option value="Papua New Guinea">Papua New Guinea</option>
                    <option value="Paraguay">Paraguay</option>
                    <option value="Peru">Peru</option>
                    <option value="Philippines">Philippines</option>
                    <option value="Pitcairn">Pitcairn</option>
                    <option value="Poland">Poland</option>
                    <option value="Portugal">Portugal</option>
                    <option value="Puerto Rico">Puerto Rico</option>
                    <option value="Qatar">Qatar</option>
                    <option value="Reunion">Reunion</option>
                    <option value="Romania">Romania</option>
                    <option value="Russian Federation">Russian Federation</option>
                    <option value="Rwanda">Rwanda</option>
                    <option value="Saint Helena">Saint Helena</option>
                    <option value="Saint Kitts and Nevis">Saint Kitts and Nevis</option>
                    <option value="Saint Lucia">Saint Lucia</option>
                    <option value="Saint Pierre and Miquelon">Saint Pierre and Miquelon</option>
                    <option value="Saint Vincent and The Grenadines">Saint Vincent and The Grenadines</option>
                    <option value="Samoa">Samoa</option>
                    <option value="San Marino">San Marino</option>
                    <option value="Sao Tome and Principe">Sao Tome and Principe</option>
                    <option value="Saudi Arabia">Saudi Arabia</option>
                    <option value="Senegal">Senegal</option>
                    <option value="Serbia">Serbia</option>
                    <option value="Seychelles">Seychelles</option>
                    <option value="Sierra Leone">Sierra Leone</option>
                    <option value="Singapore">Singapore</option>
                    <option value="Slovakia">Slovakia</option>
                    <option value="Slovenia">Slovenia</option>
                    <option value="Solomon Islands">Solomon Islands</option>
                    <option value="Somalia">Somalia</option>
                    <option value="South Africa">South Africa</option>
                    <option value="South Georgia and The South Sandwich Islands">South Georgia and The South Sandwich Islands</option>
                    <option value="Spain">Spain</option>
                    <option value="Sri Lanka">Sri Lanka</option>
                    <option value="Sudan">Sudan</option>
                    <option value="Suriname">Suriname</option>
                    <option value="Svalbard and Jan Mayen">Svalbard and Jan Mayen</option>
                    <option value="Swaziland">Swaziland</option>
                    <option value="Sweden">Sweden</option>
                    <option value="Switzerland">Switzerland</option>
                    <option value="Syrian Arab Republic">Syrian Arab Republic</option>
                    <option value="Taiwan">Taiwan</option>
                    <option value="Tajikistan">Tajikistan</option>
                    <option value="Tanzania, United Republic of">Tanzania, United Republic of</option>
                    <option value="Thailand">Thailand</option>
                    <option value="Timor-leste">Timor-leste</option>
                    <option value="Togo">Togo</option>
                    <option value="Tokelau">Tokelau</option>
                    <option value="Tonga">Tonga</option>
                    <option value="Trinidad and Tobago">Trinidad and Tobago</option>
                    <option value="Tunisia">Tunisia</option>
                    <option value="Turkey">Turkey</option>
                    <option value="Turkmenistan">Turkmenistan</option>
                    <option value="Turks and Caicos Islands">Turks and Caicos Islands</option>
                    <option value="Tuvalu">Tuvalu</option>
                    <option value="Uganda">Uganda</option>
                    <option value="Ukraine">Ukraine</option>
                    <option value="United Arab Emirates">United Arab Emirates</option>
                    <option value="United Kingdom">United Kingdom</option>
                    <option value="United States">United States</option>
                    <option value="United States Minor Outlying Islands">United States Minor Outlying Islands</option>
                    <option value="Uruguay">Uruguay</option>
                    <option value="Uzbekistan">Uzbekistan</option>
                    <option value="Vanuatu">Vanuatu</option>
                    <option value="Venezuela">Venezuela</option>
                    <option value="Viet Nam">Viet Nam</option>
                    <option value="Virgin Islands, British">Virgin Islands, British</option>
                    <option value="Virgin Islands, U.S.">Virgin Islands, U.S.</option>
                    <option value="Wallis and Futuna">Wallis and Futuna</option>
                    <option value="Western Sahara">Western Sahara</option>
                    <option value="Yemen">Yemen</option>
                    <option value="Zambia">Zambia</option>
                    <option value="Zimbabwe">Zimbabwe</option>
                </select>
            </div>
        </div>

        <div class="form-control">
            <div class="form-element">
                <p class="form-title">E-mail *</p>
                <input class="type_text" v-model="form_register.email"/>
            </div>
            <div class="form-element">
                <p class="form-title">Confirmer votre e-mail *</p>
                <input class="type_text" v-model="form_register.confirm_email"/>
            </div>
        </div>

        <hr class="separator mb-4"/>

        <div class="form-control">
            <div class="form-element">
                <p class="form-title">Mot de passe *</p>
                <input class="type_text" type="password" v-model="form_register.password"/>
            </div>
            <div class="form-element">
                <p class="form-title">Confirmer votre mot de passe *</p>
                <input class="type_text" type="password" v-model="form_register.confirm_password"/>
            </div>
        </div>

        <p class="required-fields mb-4">* Champs obligatoires</p>

        <div class="terms mb-4">
            <label class="terms_label"
            >J’accepte les <a href="download/CGV.pdf" download> conditions générales de vente et déclaration de confidentialité </a>
                <input ref="checkbox" type="checkbox" v-model="terms_accepted" @click.self="acceptTerms"/>
                <span class="checkmark"></span>
            </label>
        </div>

        <button type="button" class="btn sign-up-btn" @click="loginSignUpFromForm">Créer mon compte</button>
    </div>
</template>

<script>
import Autentification from '@/services/Autentification';

export default {
    name: 'SignupV2',
    data() {
        return {
            terms_accepted: false,
            form_register: {
                gender: '',
                fonction: '',
                nom: '',
                prenom: '',
                entreprise: '',
                tva: '',
                secteur: '',
                web: '',
                telephone: '',
                telephone_portable: '',
                addresse: '',
                code_postal: '',
                ville: '',
                country: '',
                email: '',
                confirm_email: '',
                password: '',
                confirm_password: ''
            }
        };
    },
    mounted() {
        let api_token = window.localStorage.getItem('api_token');
        this.$store.commit('setApiToken', api_token);
        this.setDefaultGender();

        // $eventbus.$on('toggle:login', function(){
        //     document.querySelector('#login').classList.toggle('opened');
        // });
    },
    methods: {
        setDefaultGender() {
            this.$refs.gender.forEach((gender) => {
                if (gender.value === 'monsieur') {
                    gender.checked = true;
                    this.form_register.gender = gender.value;
                }
            });
        },
        acceptTerms() {
            if (this.$refs.checkbox.checked) {
                this.terms_accepted = true;
            } else {
                this.terms_accepted = false;
            }
            console.log('Accept terms: ' + this.terms_accepted);
        },
        clearSignup() {
            var self = this;
            // self.form_register.gender = '';
            self.form_register.fonction = '';
            self.form_register.nom = '';
            self.form_register.prenom = '';
            self.form_register.entreprise = '';
            self.form_register.tva = '';
            self.form_register.secteur = '';
            self.form_register.web = '';
            self.form_register.telephone = '';
            self.form_register.telephone_portable = '';
            self.form_register.addresse = '';
            self.form_register.code_postal = '';
            self.form_register.ville = '';
            self.form_register.country = '';
            self.form_register.email = '';
            self.form_register.confirm_email = '';
            self.form_register.password = '';
            self.form_register.confirm_password = '';
        },
        //
        isValidEmail: function (email) {
            var re = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
            return re.test(email) ? true : false;
        },

        loginSignUpFromForm: function () {
            var self = this;
            // preia datele
            Object.entries(self.form_register).forEach((register) => {
                self.form_register[register[0]] = register.includes('email') || register.includes('confirm_email') ? self.form_register[register[0]].trim().toLowerCase() : self.form_register[register[0]].trim();
            });

            // valideaza datele
            if (self.form_register.gender.length === 0) {
                $eventbus.$emit('open:alert', 'Merci de préciser votre civilité.');
                //
            } else if (self.form_register.fonction.length === 0) {
                $eventbus.$emit('open:alert', 'Merci de préciser votre fonction.');
                //
            } else if (self.form_register.nom.length === 0) {
                $eventbus.$emit('open:alert', 'Merci de préciser votre nom.');
                //
            } else if (self.form_register.prenom.length === 0) {
                $eventbus.$emit('open:alert', 'Merci de préciser votre prenom.');
                //
            } else if (self.form_register.entreprise.length === 0) {
                $eventbus.$emit('open:alert', 'Merci de préciser votre nom de l’entreprise.');
                //
            } else if (self.form_register.tva.length === 0) {
                $eventbus.$emit('open:alert', 'Merci de préciser votre numéro de TVA.');
                //
            } else if (self.form_register.secteur.length === 0) {
                $eventbus.$emit('open:alert', 'Merci de préciser votre secteur.');
                //
            } else if (self.form_register.telephone.length === 0) {
                $eventbus.$emit('open:alert', 'Merci de préciser votre téléphone.');
                //
            } else if (self.form_register.addresse.length === 0) {
                $eventbus.$emit('open:alert', 'Merci de préciser votre adresse de facturation / rue et N°.');
                //
            } else if (self.form_register.code_postal.length === 0) {
                $eventbus.$emit('open:alert', 'Merci de préciser votre code postal.');
                //
            } else if (self.form_register.ville.length === 0) {
                $eventbus.$emit('open:alert', 'Merci de préciser votre ville.');
                //
            } else if (self.form_register.country.length === 0) {
                $eventbus.$emit('open:alert', 'Merci de préciser votre pays.');
                //
            } else if (self.form_register.email.length === 0) {
                $eventbus.$emit('open:alert', 'Merci de préciser votre e-mail.');
                //
            } else if (!self.isValidEmail(self.form_register.email)) {
                $eventbus.$emit('open:alert', 'Merci de préciser une adresse e-mail valide.');
                //
            } else if (self.form_register.confirm_email !== self.form_register.email) {
                $eventbus.$emit('open:alert', `L'adresse e-mail de confirmation ne correspond pas à votre e-mail.`);
                //
            } else if (self.form_register.password.length === 0) {
                $eventbus.$emit('open:alert', 'Merci de préciser votre mot de passe.');
                //
            } else if (self.form_register.password.length < 6) {
                $eventbus.$emit('open:alert', 'La valeur du mot de passe doit être au moins 6 caractères.');
                //
            } else if (self.form_register.confirm_password !== self.form_register.password) {
                $eventbus.$emit('open:alert', 'La confirmation ne correspond pas au mot de passe.');
                //
            } else if (!self.terms_accepted) {
                $eventbus.$emit('open:alert', `Merci d'accepter les conditions générales de vente et la politique de confidentialité.`);
                //
            } else {
                // apel
                Autentification.signup({
                    kta_id: '',
                    gender: self.form_register.gender,
                    profession: self.form_register.fonction,
                    last_name: self.form_register.nom,
                    first_name: self.form_register.prenom,
                    company: self.form_register.entreprise,
                    tva: self.form_register.tva,
                    sector: self.form_register.secteur,
                    site: self.form_register.web.length ? self.form_register.web : 'none',
                    phone: self.form_register.telephone,
                    cellphone: self.form_register.telephone_portable.length ? self.form_register.telephone_portable : 'none',
                    address: self.form_register.addresse,
                    postal_code: self.form_register.code_postal,
                    city: self.form_register.ville,
                    country: self.form_register.country,
                    email: self.form_register.email,
                    confirm_email: self.form_register.confirm_email,
                    password: self.form_register.password,
                    confirm_password: self.form_register.confirm_password,
                    terms_accepted: self.terms_accepted
                })
                        .then(function (response) {
                            var data = response.data;
                            if (data && data.error) {
                                $eventbus.$emit('open:alert', data.error.message);
                            } else {
                                $eventbus.$emit('toggle:modal');
                                $eventbus.$emit('open:alert', "Votre compte a été créé, veuillez attendre qu'il soit activé.");
                                self.clearSignup();

                                let sto = setTimeout(function () {
                                    clearTimeout(sto);

                                    if (window.parent && window.parent.MainFrame) {
                                        let MainFrame = window.parent.MainFrame;
                                        let mailSentTrigger = 'mailSentFromForm';

                                        MainFrame.Manager.Variables.register("loggedOut", "1");

                                        MainFrame.Manager.Variables.register("api_token", "0");
                                        MainFrame.EprintShop.saveItem("api_token", null);

                                        // MainFrame.EventHandler.dispatch(mailSentTrigger);

                                        MainFrame.EventHandler.dispatch('closeLogin');
                                        MainFrame.EventHandler.dispatch('loginSuccess');
                                        MainFrame.EventHandler.dispatch("userNotLoggedIn");
                                    }
                                }, 4000);
                            }
                        })
                        .catch(function (error) {
                            $eventbus.$emit('open:alert', 'Le formulaire comporte une erreur. Veuillez vérifier les informations.');
                        })
                        .then(function () {
                            // self.clearSignup();
                        });
            }
        },

        loginResetPasswordFromForm: function () {
            var self = this;
            // preia datele
            self.formular_resetare.email = self.formular_resetare.email.trim().toLowerCase();
            //
            // valideaza datele
            if (self.formular_resetare.email.length === 0) {
                $eventbus.$emit('open:alert', 'Merci de préciser votre e-mail.');
            } else if (!self.isValidEmail(self.formular_resetare.email)) {
                $eventbus.$emit('open:alert', 'Merci de préciser une adresse e-mail valide.');
            } else {
                Autentification.reset_password({
                    kta_id: '',
                    email: self.formular_resetare.email
                })
                        .then(function (result) {
                            var data = result.data;

                            if (data && data.error) {
                                $eventbus.$emit('open:alert', data.error.message);
                            } else {
                                self.formular_confirmare.email = self.formular_resetare.email;
                                $eventbus.$emit('open:confirm-password');
                            }
                        })
                        .catch(function (error) {
                            $eventbus.$emit('open:alert', 'Le formulaire comporte une erreur. Veuillez vérifier les informations.');
                        })
                        .then(function () {
                            self.clearResetPassword();
                        });
            }
        },
        loginConfirmPasswordFromForm: function () {
            var self = this;
            // preia datele
            self.formular_confirmare.code = self.formular_confirmare.code.trim();
            self.formular_confirmare.password = self.formular_confirmare.password.trim();
            self.formular_confirmare.password_confirmation = self.formular_confirmare.password_confirmation.trim();
            self.formular_confirmare.email = self.formular_confirmare.email.trim().toLowerCase();
            //
            // valideaza datele
            if (self.formular_confirmare.code.length === 0) {
                $eventbus.$emit('open:alert', 'Merci de préciser votre code.');
            } else if (self.formular_confirmare.password.length === 0) {
                $eventbus.$emit('open:alert', 'Merci de préciser votre mot de passe.');
            } else if (self.formular_confirmare.password.length < 6) {
                $eventbus.$emit('open:alert', 'La valeur du mot de passe doit être au moins 6 caractères.');
            } else if (self.formular_confirmare.password_confirmation.length === 0) {
                $eventbus.$emit('open:alert', 'Merci de préciser votre mot de passe.');
            } else if (self.formular_confirmare.password_confirmation.length < 6) {
                $eventbus.$emit('open:alert', 'La valeur du mot de passe doit être au moins 6 caractères.');
            } else if (self.formular_confirmare.password !== self.formular_confirmare.password_confirmation) {
                $eventbus.$emit('open:alert', 'Merci pour les mots de passe, mais ils ne correspondent pas.');
            } else {
                Autentification.confirm_password({
                    kta_id: '',
                    token: self.formular_confirmare.code,
                    password: self.formular_confirmare.password,
                    password_confirmation: self.formular_confirmare.password_confirmation,
                    email: self.formular_confirmare.email
                })
                        .then(function (result) {
                            var data = result.data;

                            if (data && data.error) {
                                $eventbus.$emit('open:alert', data.error.message);
                            } else {
                                $eventbus.$emit('open:alert', data.message);
                                $eventbus.$emit('toggle:login');
                            }
                        })
                        .catch(function (error) {
                            $eventbus.$emit('open:alert', 'Le formulaire comporte une erreur. Veuillez vérifier les informations.');
                        })
                        .then(function () {
                            self.clearConfirmPassword();
                        });
            }
        }
    }
};
</script>

<style lang="scss" scoped>
#signup_v2 {
    width: 100%;
    max-width: 586px;
    padding: 1rem;

    .form-control {
        * {
            user-select: none;
            font-size: 13px;
            color: #6b6c6f;
        }

        display: flex;
        flex-direction: column;
        justify-content: space-between;
        @media (min-width: 768px) {
            flex-direction: row;
        }

        .form-element {
            margin-bottom: 1rem;
            width: 100%;

            &.form-addresse {
                width: 100%;
                margin-right: 0 !important;
            }

            @media (min-width: 768px) {
                width: 50%;
                margin-right: 1.5rem;
                &:last-of-type {
                    margin-right: 0;
                }
            }

            .type_text {
                width: 100%;
                border: 1px solid #dfe2e6;
                border-radius: 25px;
                padding-block: 0.2rem;
                padding-inline: 1rem;
                outline: none;
                color: #6b6c6f;
                font-size: 13px;

                &:focus {
                    border-color: #6b6c6f;
                }
            }

            .form-title {
                margin-bottom: 0.3rem;
                font-weight: bold;
            }

            .gender_wrapper {
                display: flex;

                .type_radio {
                    display: block;
                    position: relative;
                    padding-left: 15px;
                    cursor: pointer;
                    user-select: none;
                    margin-right: 1.5rem;

                    &:hover {
                        input {
                            ~ {
                                .checkmark {
                                    border-color: #01a0c6;
                                }
                            }
                        }
                    }

                    input {
                        position: absolute;
                        opacity: 0;
                        cursor: pointer;
                        pointer-events: none;

                        &:checked {
                            ~ {
                                .checkmark {
                                    background-color: #01a0c6;
                                    border: none;
                                }
                            }
                        }
                    }

                    .checkmark {
                        position: absolute;
                        top: 0;
                        left: 0;
                        height: 12px;
                        width: 12px;
                        border: 1px solid #cccccc;
                        border-radius: 50%;
                    }
                }
            }
        }
    }

    .required-fields {
        font-size: 10px;
        color: #6b6c6f;
        text-align: center;
    }

    .terms {
        font-size: 12px;
        color: #6b6c6f;
        font-weight: bold;

        .terms_label {
            display: block;
            position: relative;
            cursor: pointer;
            user-select: none;
            padding-left: 26px;

            a {
                text-decoration: underline;
                color: #5882ff;
            }

            &:hover {
                input {
                    ~ {
                        .checkmark {
                            background-color: rgba(223, 226, 230, 0.2);
                            border-color: #4e4e4e;
                        }
                    }
                }
            }

            input {
                position: absolute;
                opacity: 0;
                cursor: pointer;
                width: 0;
                height: 0;

                &:checked {
                    ~ {
                        .checkmark {
                            background-color: #01a0c6;
                            border: none;

                            &:after {
                                display: block;
                            }
                        }
                    }
                }
            }

            .checkmark {
                position: absolute;
                top: 0;
                left: 0;
                height: 18px;
                width: 18px;
                border: 2px solid #dfe2e6;
                border-radius: 3px;
                transition: 0.5s;

                &::after {
                    content: '';
                    position: absolute;
                    display: none;
                    left: 7px;
                    top: 3px;
                    width: 5px;
                    height: 10px;
                    border: solid white;
                    border-width: 0 2px 2px 0;
                    transform: rotate(45deg);
                }
            }
        }
    }

    .btn {
        font-size: 14px;
        outline: none;
        border: none;
        width: 100%;
        max-width: 160px;
        height: 40px;
        border-radius: 2rem;
        font-weight: 500;
        user-select: none;

        &.sign-up-btn {
            border: 2px solid #4e4e4e;
            color: #4e4e4e;
        }
    }
}
</style>
